var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 80,
    viewBox: "0 0 37.5 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-upload",
    "data-name": "Icon awesome-file-upload",
    d: "M21.875,13.281V0H2.344A2.338,2.338,0,0,0,0,2.344V47.656A2.338,2.338,0,0,0,2.344,50H35.156A2.338,2.338,0,0,0,37.5,47.656V15.625H24.219A2.351,2.351,0,0,1,21.875,13.281ZM28.24,34.376H21.875v7.813a1.562,1.562,0,0,1-1.562,1.563H17.188a1.562,1.562,0,0,1-1.563-1.562V34.376H9.26a1.563,1.563,0,0,1-1.1-2.672l9.416-9.346a1.665,1.665,0,0,1,2.348,0L29.339,31.7A1.562,1.562,0,0,1,28.24,34.376Zm8.576-24.122L27.256.684A2.342,2.342,0,0,0,25.6,0H25V12.5H37.5v-.6A2.336,2.336,0,0,0,36.816,10.254Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/File_Upload.2159214283c332c1f7eaf316453ec96b.svg";
export { ForwardRef as ReactComponent };